import { z } from "zod";
import { DASHBOARD_TABS } from "./tabs";

/** A real calendar day: "2026-13-45" and "2026-02-30" match the pattern but are not dates. */
const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((s) => {
    const t = Date.parse(`${s}T00:00:00Z`);
    return !Number.isNaN(t) && new Date(t).toISOString().slice(0, 10) === s;
  });

/**
 * The tab and the period are the URL, like every list in the app: a refresh or a shared link lands
 * on the same department and dates. A hand-edited or stale value falls back to its default instead
 * of failing the route, which would replace the whole app with the router's error screen.
 */
export const dashboardSearch = z.object({
  tab: z.enum(DASHBOARD_TABS).optional().catch(undefined),
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
  date: isoDate.optional().catch(undefined),
  days: z.number().int().min(1).max(3650).optional().catch(undefined),
});
